import * as React from 'react';

export default class Animation extends React.Component {

	render () {
		return this.props.children;
	}

}
